import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section className="w-full bg-cream" data-id="element-73" data-mp="eiv4wuw1x6js">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14 lg:py-20" data-id="element-74" data-mp="ei1wlphg28zj">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-75" data-mp="4lyswf6y22ah">
          <h1 className="font-display text-4xl font-black leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-[3.6rem]" data-id="element-76" data-mp="xae9351taqne">
            Cociná el domingo,
            <span className="text-tomato" data-id="element-77" data-mp="s9q75oc1opee"> descansá toda la semana.</span>
          </h1>
          <p className="mt-5 max-w-xl font-sans text-lg leading-relaxed text-ink/80 sm:text-xl" data-id="element-78" data-mp="nbexpepnwgwp">
            El método para resolver los almuerzos y cenas de tu familia en solo{' '}
            <strong className="font-bold text-ink" data-id="element-79" data-mp="3825y4q50c7ld">3 horas</strong>.
          </p>
          <p className="mt-4 max-w-xl font-sans text-base leading-relaxed text-muted" data-id="element-80" data-mp="3j8sfs1yzrlqd">
            Dejá de tirar comida y de gastar una fortuna en pedidos de último momento.
            Recuperá tus tardes con el sistema de planificación que está transformando las
            cocinas argentinas.
          </p>

          <div className="mt-8" data-id="element-81" data-mp="3e8whmjcz6oiq">
            <CtaButton size="lg" subLabel="Acceso inmediato · Garantía de 7 días" data-id="element-82" data-mp="3e7uydrlt2vpx" />
          </div>
        </motion.div>

        <div className="relative" data-id="element-83" data-mp="30fya5yn9d5yt">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/c7ee5fdf-6b44-47e8-a0f7-f9ab860ee18d.jpg" alt="Mesada con milanesas, guiso, tarta, ensalada y arroz en recipientes rotulados, listos para la semana" className="w-full rounded-2xl object-cover shadow-card" data-id="element-84" data-mp="3599iy5bmrwtd" />
          <div className="absolute -bottom-5 left-4 rounded-xl bg-white px-5 py-3 shadow-card sm:left-6" data-id="element-85" data-mp="2hkgj3xrw14th">
            <p className="font-display text-2xl font-black leading-none text-tomato" data-id="element-86" data-mp="2lk8uei8o1p2j">3 h</p>
            <p className="mt-1 font-sans text-xs font-semibold uppercase tracking-wide text-muted" data-id="element-87" data-mp="s2tffr2zujsd">
              una vez por semana
            </p>
          </div>
        </div>
      </div>
    </section>;
}